<template>
  <div>
    <vue-qrcode @getScanResult="handleCode"></vue-qrcode>
  </div>
</template>
<script>
import qrcode from "../components/scanCodePage.vue";

export default {
  components: {
    "vue-qrcode": qrcode,
  },
  name: "qrcode",
  data() {
    return {};
  },
  created() {
    console.log(this.$route);
  },
  methods: {
    handleCode(e) {
      let { type } = this.$route.params;
      let id = e;
      if (type == 1 && id) {
        this.$router.push(`/tekeOrder/tOrderIndex/${id}`);
      } else if (type == 2 && id) {
        this.$router.push(`/tekeMeal/tMealIndex/${id}/${false}`);
      } else if (type == 3 && id) {
        this.$router.push(`/sendMeal/sMealIndex/${id}`);
      } else if (type == 4 && id) {
        this.$router.push(`/dispatch/dIndex/${id}`);
      }else if(type == 5 && id) {
        this.$router.push({ name: 'orderMineList', params: { id }});
      }
    },
  },
};
</script>